function validateEmail(email) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
}

function validateName(name) {
  // const nameRegex = /^\w+\s\w+$/; // original
  // const nameRegex = /^[a-z]+(?:\s[a-z]+)+$/;
  const nameRegex = /(?:[A-Za-z]+ ){1}[A-Za-z]+/;
  return nameRegex.test(name);
}

function validateInput(message) {
  return message.trim()
}

export { validateEmail, validateName, validateInput };
